import { core } from '@musinsa/pbo-core'

/**
 * 컬럼 41종 — `V2Page.generated.tsx` 의 `COLUMNS` 40종을 그대로 옮기고 `dataIndex` 만 2.0 응답 키(camelCase)로
 * 교체한다(D1). 제목·폭·순서·정렬·`required`·`variant` 는 셸과 동일해야 대조(6장 검증)를 통과한다.
 * 셸에 없는 SKUID(LOGISPRD-12866)를 바코드 뒤에 하나 더했다.
 *
 * 변경한 지점 두 곳:
 *  - 출고센터(`GI_WH_NM`→`giWhNm`)는 셸에 `variant:'input'` 이 있으나 뺐다. 저장 API(3.3)의 patch
 *    대상 필드에 이 값이 없어 편집해도 반영될 곳이 없다(D14, 피드백 14). 실제 편집 셀은 6종이다.
 *  - 입고센터(`WH_NM`)는 2.0 DTO 에 대응 필드가 없다 — TODO(api), dataIndex 를 비워 항상 빈 칸으로 둔다(4장, D8).
 */
export const RETURN_MONITORING_COLUMNS = [
  { title: 'No', key: '__no', width: 48, align: 'center', render: (_v: unknown, _r: unknown, i: number) => i + 1 },
  { title: '고객반품접수일자', dataIndex: 'receiptDate', width: 150 },
  { title: '반품접수일(업로드)', dataIndex: 'rtnDate', width: 160 },
  { title: '실입고 결과내역', dataIndex: 'actFlag', width: 140, align: 'center', variant: 'checkbox' },
  { title: '등록센터', dataIndex: 'rtnWhNm', width: 100 },
  {
    title: '반송상태',
    dataIndex: 'ordStatus',
    width: 120,
    align: 'left',
    variant: 'tag',
    variantProps: {
      statusMap: {
        검수완료: { text: '검수완료', color: 'cyan' },
        반품취소: { text: '반품취소', color: 'red' },
        센터도착: { text: '센터도착', color: 'purple' },
        수거예정: { text: '수거예정', color: 'gold' },
        수거완료: { text: '수거완료', color: 'orange' },
        입고대기: { text: '입고대기', color: 'volcano' },
        입고완료: { text: '입고완료', color: 'green' },
        접수완료: { text: '접수완료', color: 'blue' },
        반품배송중: { text: '반품배송중', color: 'geekblue' },
      },
    },
  },
  { title: '원송장번호', dataIndex: 'orgInvoiceNo', width: 176, required: true, variant: 'input' },
  { title: '출고 주문번호', dataIndex: 'giOrdNo', width: 140 },
  { title: '출고 주문일련번호', dataIndex: 'giOrdOptNo', width: 170 },
  { title: '화주코드', dataIndex: 'sprNm', width: 140 },
  { title: '반송번호', dataIndex: 'rtnInvoiceNo', width: 176, variant: 'input' },
  { title: '택배사', dataIndex: 'carrier', width: 110 },
  { title: '클레임유형', dataIndex: 'claimType', width: 123, variant: 'input' },
  { title: '고객클레임 (비고)', dataIndex: 'customerClaim', width: 200, variant: 'input' },
  { title: '비고사항(센터)', dataIndex: 'centerClaim', width: 150, variant: 'input' },
  { title: '바코드', dataIndex: 'barcode', width: 167, required: true, variant: 'input' },
  { title: 'SKUID', dataIndex: 'skuId', width: 150 },
  { title: '상품명', dataIndex: 'gdsNm', width: 240 },
  { title: '옵션명', dataIndex: 'gdsOpt', width: 90 },
  { title: '반품수량', dataIndex: 'rtnQty', width: 100, align: 'right', required: true },
  // TODO(dev): 출고센터는 저장 대상 필드가 없어 읽기 전용으로 되돌린다(D14) — variant:'input' 제거.
  { title: '출고센터', dataIndex: 'giWhNm', width: 100 },
  // TODO(api): WH_NM(입고센터) — ReturnMonitoringItemDto 에 대응 필드 없음. UI_RETURN_MONITORING 물리
  // 컬럼 부재(RTN_WH_NM 만 존재), 1.0 도 항상 빈 값. BE 결함 보존 명시(4장) — 컬럼은 남기고 빈 칸.
  { title: '입고센터', width: 100 },
  { title: '도착일자 (실입고)', dataIndex: 'actReturnDate', width: 160 },
  { title: '자사몰 주문번호', dataIndex: 'companyOrdNo', width: 150 },
  { title: '자사몰 주문일련번호', dataIndex: 'companyOrdOptNo', width: 180 },
  { title: '셀링툴 주문번호', dataIndex: 'refOrdNo', width: 150 },
  { title: '셀링툴 주문일련번호', dataIndex: 'refOrdOptNo', width: 180 },
  { title: '수령자', dataIndex: 'trsNm', width: 100 },
  { title: '수령지', dataIndex: 'trsAddr', width: 210 },
  { title: '전화번호', dataIndex: 'trsPhone', width: 140 },
  { title: '마감일자', dataIndex: 'clsDate', width: 120 },
  { title: '브랜드', dataIndex: 'brdNm', width: 140 },
  { title: '출고 마감일자', dataIndex: 'giActDate', width: 140 },
  { title: '입고완료일자', dataIndex: 'grActDate', width: 130 },
  { title: '검수완료일자', dataIndex: 'inspectDate', width: 130 },
  { title: '생성자', dataIndex: 'insBy', width: 100 },
  { title: '생성일자', dataIndex: 'insDate', width: 120 },
  { title: '수정자', dataIndex: 'updBy', width: 100 },
  { title: '반품작업번호', dataIndex: 'etc1', width: 140 },
  { title: '반품/교환', dataIndex: 'rtnExcDiv', width: 100 },
  { title: '검수시작시간', dataIndex: 'recStartDate', width: 160 },
] as core.CoreColumnType[]
